import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_SearchArea = _resolveComponent("SearchArea")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppBreadcrumb, { items: _ctx.breadcrumbItems }, null, 8, ["items"]),
      _createVNode(_component_el_row, { class: "align-center" }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("h1", null, "File usages", -1)
        ])),
        _: 1,
        __: [4]
      }),
      _createVNode(_component_SearchArea, {
        label: "file usages",
        "pagination-data": _ctx.paginationData,
        headers: _ctx.headers,
        query: _ctx.query,
        loading: _ctx.isLoading,
        action: false,
        onSearch: _ctx.handleClickSearch,
        onSizeChange: _ctx.handleClickSizeChange,
        onCurrentChange: _ctx.handleClickCurrentChange,
        onSort: _ctx.handleClickSort
      }, {
        searchInputs: _withCtx(() => [
          _createVNode(_component_el_row, {
            gutter: 10,
            class: "app-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { sm: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.searchQuery.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery.date) = $event)),
                    type: "month",
                    format: "YYYY-MM",
                    "value-format": "YYYY-MM",
                    placeholder: "Date",
                    onChange: _ctx.handleClickSearch
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { sm: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.searchQuery.fileType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery.fileType) = $event)),
                    clearable: "",
                    placeholder: "File Type",
                    class: "mr-4",
                    onChange: _ctx.handleClickSearch
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        label: "pdf",
                        value: "pdf"
                      })),
                      (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        label: "docx",
                        value: "docx"
                      }))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { sm: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchQuery.organizationName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery.organizationName) = $event)),
                    clearable: "",
                    placeholder: "Organization name",
                    class: "mr-4",
                    onChange: _ctx.handleClickSearch
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { sm: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchQuery.licenseKey,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery.licenseKey) = $event)),
                    clearable: "",
                    placeholder: "License key",
                    class: "mr-4",
                    onChange: _ctx.handleClickSearch
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["pagination-data", "headers", "query", "loading", "onSearch", "onSizeChange", "onCurrentChange", "onSort"])
    ]),
    _: 1
  }))
}